var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0300388 4.41223C0.0665824 4.51246 0.155462 4.61748 0.352301 4.793C0.545746 4.96549 0.603498 4.9925 0.78029 4.99307C0.882974 4.9934 0.93997 4.98495 0.991321 4.96179C1.03893 4.94034 1.61717 4.40441 2.78078 3.30328L4.49989 1.67649L6.21883 3.30423C7.16425 4.19949 7.96546 4.94516 7.99932 4.96128C8.03317 4.97738 8.11735 4.99403 8.18641 4.99828C8.3797 5.01017 8.46752 4.96479 8.72183 4.72168C8.89221 4.5588 8.93197 4.51091 8.96371 4.43028C9.00889 4.31558 9.01139 4.23936 8.97398 4.11723C8.9469 4.02879 8.89785 3.98072 6.86807 2.05377C5.18852 0.459321 4.77302 0.0732352 4.70195 0.0410797C4.63717 0.0117576 4.58393 0.00128861 4.49972 0.00128861C4.26788 0.0012886 4.41096 -0.121883 2.13198 2.03957C0.158188 3.91157 0.0704337 3.99737 0.0348574 4.08982C-0.0100747 4.20651 -0.0114464 4.29847 0.0300388 4.41223Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardArrow);
export default __webpack_public_path__ + "static/media/upward_arrow.a6544702e60139b69ed40a66f5c7d606.svg";
export { ForwardRef as ReactComponent };